var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRoad = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 496 496"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M119.178 72.985 0 423.015h60.237l86.43-350.03zm257.644 0h-27.489l86.43 350.03H496zm-206.646 0L83.93 423.015h127.624l3.514-51.512h65.864l3.514 51.512H412.07l-86.243-350.03zm66.475 4.013h22.699l3.596 49.085h-29.893zm-7.193 98.169h37.086l3.597 49.084h-44.283zm-10.791 147.25 3.596-49.082h51.475l3.599 49.082z"
})));
export default SvgRoad;